import React from 'react';
import NavigationLink, { NavigationLinkProps } from './NavigationLink';

interface NavigationDesktopProps {
  links: NavigationLinkProps[];
}

const NavigationDesktop: React.FC<NavigationDesktopProps> = ({ links }) => {
  return (
    <nav className="ckp-m-navigation__wrapper">
      <ul className="ckp-m-navigation">
        {links.map((linkProps) => (
          <li className="ckp-m-navigation__item" key={`navigation-${linkProps.href}`}>
            <NavigationLink {...linkProps} />
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default NavigationDesktop;
